export default "__VITE_ASSET__CA1OOKc1__"